import React from 'react';
import './empty-state-view.scss';
import { View, Text } from '../../common';

interface EmptyStateViewProps {
  imageSrc?: string;
  message: string;
  className?: string;
  description?: string;
}

export const EmptyStateView: React.FC<EmptyStateViewProps> = ({
  imageSrc,
  message,
  className = '',
  description = '',
}) => {
  return (
    <View className={`empty-state-view ${className}`}>
      <View className="empty-state-view-content">
        {imageSrc && (
          <img src={imageSrc} alt="Empty State" width={180} height={180} />
        )}
        <Text className="empty-state-view-content-text font-semibold">
          {message}
        </Text>
        {description && (
          <Text className="empty-state-view-content-description font-regular">
            {description}
          </Text>
        )}
      </View>
    </View>
  );
};
